<div
    class="content-with-side-menu main-content content-above-bottom-menu"
    [style.margin-bottom.px]="bottomMenuHeight()"
>
    <div class="row pt-4 pb-2">
        <div class="col">
            <h2 class="page-header" hznTestId="sell-camp-title">{{ "SellCamp.Title" | translate }}</h2>
        </div>
    </div>
    @if (waitingForPaymentProcessorResponse) {
        <div>
            <bcu-local-spinner
                [size]="50"
                [visible]="waitingForPaymentProcessorResponse"
            ></bcu-local-spinner>
            <div class="row size-16">
                <div class="col text-center main-blue mt-5">
                    {{
                        "SellCamp.ValidatingPaymentProcessorPayment" | translate
                    }}
                </div>
            </div>
        </div>
    }

    <form [formGroup]="sellCampForm">
        <div class="row" [hidden]="waitingForPaymentProcessorResponse">
            <div class="col-8">
                <div class="card">
                    <div class="card-body">
                        <div class="card-title main-blue font-weight-bold">
                            {{ "SellCamp.Attendee" | translate }}
                        </div>

                        <div class="row mt-2">
                            <div class="col">
                                <label class="main-grey">{{
                                    "SellCamp.Person" | translate
                                }}</label>
                                <app-member-search
                                    hznTestId="sell-camp-member-search"
                                    (membershipSelected)="
                                        onMemberSelected($event)
                                    "
                                ></app-member-search>
                            </div>
                            <div class="col">
                                <label class="main-grey">{{
                                    "SellCamp.Child" | translate
                                }}</label>
                                <bcu-drop-down-cf2
                                    [maxHeigth]="300"
                                    [selectAll]="false"
                                    placeHolder="Select Child"
                                    [multiple]="false"
                                    formControlName="childId"
                                    hznTestId="sell-camp-child"
                                    [isDisabled]="children?.length < 1"
                                    [options]="children"
                                    valueKey="id"
                                    displayKey="value"
                                ></bcu-drop-down-cf2>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-4">
                    <div class="card-body h-100">
                        <div class="card-title main-blue font-weight-bold">
                            {{ "SellCamp.SelectCamp" | translate }}
                        </div>

                        <div class="row">
                            <div class="col">
                                <label class="main-grey">{{
                                    "SellCamp.Club" | translate
                                }}</label>
                                <bcu-drop-down-cf2
                                    [maxHeigth]="300"
                                    [selectAll]="false"
                                    placeHolder="Select Club"
                                    [multiple]="false"
                                    formControlName="clubId"
                                    hznTestId="sell-camp-club"
                                    [options]="clubDropdownItems"
                                    valueKey="id"
                                    displayKey="value"
                                ></bcu-drop-down-cf2>
                            </div>
                            <div class="col"></div>
                        </div>

                        <div class="row mt-4">
                            <div class="col">
                                <label class="main-grey">{{
                                    "SellCamp.Program" | translate
                                }}</label>
                                <bcu-drop-down-cf2
                                    [maxHeigth]="300"
                                    [selectAll]="false"
                                    placeHolder="Select Program"
                                    [multiple]="false"
                                    formControlName="campId"
                                    hznTestId="sell-camp-program"
                                    [isDisabled]="!selectedClubId"
                                    [options]="campsDropDownItems"
                                    valueKey="id"
                                    displayKey="value"
                                ></bcu-drop-down-cf2>
                            </div>
                            <div class="col">
                                <label class="main-grey">{{
                                    "SellCamp.Session" | translate
                                }}</label>
                                <bcu-drop-down-cf2
                                    [maxHeigth]="300"
                                    [selectAll]="false"
                                    placeHolder="Select Session"
                                    [multiple]="false"
                                    formControlName="sessionId"
                                    hznTestId="sell-camp-session"
                                    [options]="sessions"
                                    valueKey="id"
                                    [isDisabled]="!campDetails"
                                    displayKey="value"
                                ></bcu-drop-down-cf2>
                            </div>
                        </div>

                        <app-selected-session-info
                            [session]="selectedSession"
                        ></app-selected-session-info>

                        <div class="row mt-4">
                            <div class="col">
                                <label class="main-grey">{{
                                    "SellCamp.Variant" | translate
                                }}</label>
                                <bcu-drop-down-cf2
                                    [maxHeigth]="300"
                                    [selectAll]="false"
                                    placeHolder="Select Variant"
                                    [multiple]="false"
                                    formControlName="sessionVariantId"
                                    hznTestId="sell-camp-variant"
                                    [isDisabled]="
                                        !campDetails || variants?.length < 1
                                    "
                                    [options]="variants"
                                    valueKey="id"
                                    displayKey="value"
                                ></bcu-drop-down-cf2>
                            </div>
                            <div class="col">
                                <label class="main-grey">{{
                                    "SellCamp.Options" | translate
                                }}</label>
                                <bcu-drop-down-cf2
                                    [maxHeigth]="300"
                                    placeHolder="Select Option"
                                    [displayItemNamesIfAllSelected]="true"
                                    [multiple]="true"
                                    formControlName="optionIds"
                                    hznTestId="sell-camp-options"
                                    [isDisabled]="
                                        !campDetails || options?.length < 1
                                    "
                                    [options]="options"
                                    valueKey="id"
                                    displayKey="value"
                                ></bcu-drop-down-cf2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <app-sell-camp-summary
                    [summary]="summary"
                ></app-sell-camp-summary>
                <app-sell-camp-coupon
                    [summary]="summary"
                    formControlName="couponCode"
                ></app-sell-camp-coupon>
            </div>
        </div>
    </form>
</div>

@if (!waitingForPaymentProcessorResponse) {
    <div
        #bottomMenu
        class="bottom-menu d-flex justify-content-end align-items-center"
    >
        @if (summary) {
            <div class="mr-2 size-16" hznTestId="sell-camp-total">
                {{ "SellCamp.Total" | translate }}
                <span class="pl-1">{{ summary.price | currency }}</span>
            </div>
        }
        @if (!canFinalizeWithoutPaying) {
            <button
                class="btn btn-success"
                [disabled]="!sellCampForm.valid"
                hznTestId="sell-camp-checkout"
                (click)="goToCheckout()"
            >
                {{ "SellCamp.GoToCheckout" | translate }}
            </button>
        }
        @if (canFinalizeWithoutPaying) {
            <button
                class="btn btn-success"
                [disabled]="!sellCampForm.valid"
                hznTestId="sell-camp-finalize"
                (click)="finalizePurchase()"
            >
                {{ "SellCamp.Finalize" | translate }}
            </button>
        }
    </div>
}
